import React from 'react';

import { styled } from '@mui/material/styles';
import classnames from 'classnames';

import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Card } from '../components/Card';
import Icon from '../components/Icon';
import { Color } from '../../theme';


const Container = styled('section')`
  background-color: white;
  padding-bottom: 0;

  .cards {
    margin-top: 20px;
    display: flex;
    justify-content: space-evenly;
    gap: 12px;

    .Card {
      flex: unset;
    }
  }

  .location-feature {
    margin-bottom: 5px;

    &.flex {
      display: flex;
      gap: 8px;
      align-items: center;
    }

    a {
      color: unset;

      :hover {
        color: ${Color.green};
        border-bottom: unset;
      }
    }
  }

  @media only screen and (max-width: 767px) {
  }
`;

const StyledIcon = styled(Icon)`
  color: ${Color.green};
  display: block;
`;

type Props = {
  className?: string;
};

const Locations = ({ className }: Props) => (
  <Container className={classnames('Locations', className)} id='contact'>
    <div className='row'>
      <h2>Contact Us</h2>
    </div>
    <div className='row'>
      <div className='cards'>
        <Card
          header={<h3>Loadout Location</h3>}
          content={
            <>
              <div className='location-feature'>2295 Burnett Blvd</div>
              <div className='location-feature'>Wilmington, NC 28401</div>
              <div className='location-feature'>(910) 408-2059</div>
              <div className='location-feature flex'>
                <StyledIcon icon={faEnvelope} />
                <a href="mailto:accounting@coastalcementllc.com">accounting@coastalcementllc.com</a>
              </div>
            </>
          }
        />
        <Card
          header={<h3>Mailing Address</h3>}
          content={
            <>
              <div className='location-feature'>PO Box 159</div>
              <div className='location-feature'>Lake City, SC 29560</div>
            </>
          }
        />
      </div>
    </div>
  </Container>
);

export default Locations;
